import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { MediaQuery } from '@grandvisionhq/common';
import { useReviewsContext, Actions } from '@grandvisionhq/reviews';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { getActiveVariant } from '../../helpers.js';
import { pushPdpEventToDataLayer } from '../../utils/DataLayer/data-layer.js';
import { useProductViewHistory } from '../../utils/use-product-view-history.js';
import { CTAButton } from './Components/CTAButton/CTAButton.js';
import PackageSelector from './Components/PackageSelector/PackageSelector.js';
import { triggerDataLayerEvent, EventAction } from './data-layer-utils.js';
import Solutions$1 from './Solutions.js';
import { useBrandLink } from '../utils/use-brand-link.js';

const SolutionsContainer = ({ activeSku , addToCartRef , productTypeUsps , stickyTop , variant , product , showStickyButton , specificationConfiguration , handleVariantPick , renderAddToCartButton , maxOrderableQuantity , onCTAClick , productImageGallery , disclaimer ,  })=>{
    const isSmallScreen = MediaQuery.useIsBelow(MediaQuery.BreakpointName.TABLET_LANDSCAPE);
    const { currency , locale , getLabel  } = useIntl();
    const { availability  } = variant;
    const variants = React.useMemo(()=>[
            product.masterVariant,
            ...product.variants
        ]
    , [
        product.masterVariant,
        product.variants
    ]);
    const { isProductLabelEnabled  } = useFeatureToggles();
    const productViewHistory = useProductViewHistory();
    React.useEffect(()=>{
        productViewHistory.remove(variants.map((v)=>v.sku || ''
        ));
        productViewHistory.add(variant.sku);
    // Adding productViewHistory to deps will cause an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        variants,
        variant.sku
    ]);
    const reviews = useReviewsContext();
    React.useEffect(()=>{
        if (reviews.enabled) {
            reviews.dispatch(Actions.updateReviewDisplay({
                variantId: activeSku
            }));
        }
    }, [
        activeSku,
        reviews
    ]);
    React.useEffect(()=>{
        pushPdpEventToDataLayer(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, activeSku, currency);
    }, [
        activeSku
    ]);
    const [selectedQuantity, setSelectedQuantity] = React.useState(1);
    var ref;
    const availableQuantity = (ref = availability === null || availability === void 0 ? void 0 : availability.availableQuantity) !== null && ref !== void 0 ? ref : 0;
    const maxOrderableQuantityCalculated = maxOrderableQuantity !== null && maxOrderableQuantity !== void 0 ? maxOrderableQuantity : 5;
    const isOrderable = (variant === null || variant === void 0 ? void 0 : variant.channelAvailability) === 'ONLINE';
    const onIncreaseQuantity = React.useCallback(()=>(setSelectedQuantity((prevSelectedQuantity)=>prevSelectedQuantity + 1
        ), triggerDataLayerEvent(EventAction.QuantityIncrease))
    , []);
    const onDecreaseQuantity = React.useCallback(()=>(setSelectedQuantity((prevSelectedQuantity)=>prevSelectedQuantity - 1
        ), triggerDataLayerEvent(EventAction.QuantityDecrease))
    , []);
    const brandLink = useBrandLink(product);
    const brandModel = `${variant.contactLensCareType} ${variant.packageOption}`;
    const labels = {
        selectAmount: getLabel('products.solutions.selectAmount'),
        selectVolume: getLabel('products.solutions.selectVolume')
    };
    const descriptionConfig = {
        specificationVariant: getActiveVariant(product, activeSku),
        specificationConfiguration
    };
    var _discountedPrice;
    const calculatedTotalPrice = selectedQuantity > 1 ? selectedQuantity * ((_discountedPrice = variant.price.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : variant.price.originalPrice) : null;
    const ctaButton = /*#__PURE__*/ React.createElement(CTAButton, {
        isOrderable: isOrderable,
        renderAddToCartButton: renderAddToCartButton,
        activeSku: activeSku,
        calculatedPrice: calculatedTotalPrice,
        currency: currency,
        selectedQuantity: selectedQuantity,
        addToCartCallback: onCTAClick
    });
    const packageSelector = React.useMemo(()=>{
        const handleVariantPickAndEvent = (event, sku, pickedSolutionsVolume)=>{
            handleVariantPick(event, sku);
            triggerDataLayerEvent(EventAction.SelectVolume, pickedSolutionsVolume);
        };
        return variants.length > 1 ? /*#__PURE__*/ React.createElement(PackageSelector, {
            variants: variants,
            label: labels.selectVolume,
            selectedPackage: activeSku,
            handleVariantPick: handleVariantPickAndEvent
        }) : null;
    }, [
        activeSku,
        labels.selectVolume,
        handleVariantPick,
        variants
    ]);
    return /*#__PURE__*/ React.createElement(Solutions$1, {
        addToCartRef: addToCartRef,
        availableQuantity: availableQuantity,
        brandLink: brandLink,
        brandModel: brandModel,
        currency: currency,
        ctaButton: ctaButton,
        isSmallScreen: isSmallScreen,
        labels: labels,
        productTypeUsps: productTypeUsps,
        showStickyButton: showStickyButton,
        stickyTop: stickyTop,
        variant: variant,
        descriptionConfig: descriptionConfig,
        packageSelector: packageSelector,
        selectedQuantity: selectedQuantity,
        onDecreaseQuantity: onDecreaseQuantity,
        onIncreaseQuantity: onIncreaseQuantity,
        isOrderable: isOrderable,
        isProductLabelEnabled: isProductLabelEnabled,
        maxOrderableQuantity: maxOrderableQuantityCalculated,
        productImageGallery: productImageGallery,
        disclaimer: disclaimer,
        quantity: selectedQuantity
    });
};
var Solutions = SolutionsContainer;

export { SolutionsContainer, Solutions as default };
//# sourceMappingURL=SolutionsContainer.js.map
